export const pct = (value: number | null | undefined, digits = 1): string =>
  value === null || value === undefined ? '--' : value.toFixed(digits) + '%';

export const num = (value: number | null | undefined): string =>
  value === null || value === undefined ? '--' : value.toLocaleString();

export const dateTime = (value: string | Date | null | undefined): string => {
  if (!value) return '--';
  const d = typeof value === 'string' ? new Date(value) : value;
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const dateOnly = (value: string | Date | null | undefined): string => {
  if (!value) return '--';
  const d = typeof value === 'string' ? new Date(value) : value;
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });
};

export const relative = (value: string | Date | null | undefined): string => {
  if (!value) return '--';
  const d = typeof value === 'string' ? new Date(value) : value;
  const seconds = Math.round((Date.now() - d.getTime()) / 1000);
  if (seconds < 60) return seconds + 's ago';
  if (seconds < 3600) return Math.round(seconds / 60) + 'm ago';
  if (seconds < 86400) return Math.round(seconds / 3600) + 'h ago';
  return Math.round(seconds / 86400) + 'd ago';
};

export const titleCase = (value: string): string =>
  value
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const gradeColour = (grade: string | null): string => {
  switch (grade) {
    case 'A':
      return 'text-emerald-700 bg-emerald-50 border-emerald-200';
    case 'B':
      return 'text-lime-700 bg-lime-50 border-lime-200';
    case 'C':
      return 'text-amber-700 bg-amber-50 border-amber-200';
    case 'D':
      return 'text-orange-700 bg-orange-50 border-orange-200';
    case 'F':
      return 'text-red-700 bg-red-50 border-red-200';
    default:
      return 'text-ink-600 bg-ink-100 border-ink-200';
  }
};

export const classificationColour = (classification: string): string => {
  switch (classification) {
    case 'human':
      return 'text-emerald-700 bg-emerald-50 border-emerald-200';
    case 'machine_open':
      return 'text-sky-700 bg-sky-50 border-sky-200';
    case 'suspected_bot':
      return 'text-amber-700 bg-amber-50 border-amber-200';
    case 'bot':
      return 'text-red-700 bg-red-50 border-red-200';
    default:
      return 'text-ink-600 bg-ink-100 border-ink-200';
  }
};
